export default {
  title: 'Nhật Ký SMS',

  // Form related
  form: {
    timeRange: 'Khoảng Thời Gian',
    sendTime: 'Thời Gian Gửi',
    startDate: 'Ngày Bắt Đầu',
    endDate: 'Ngày Kết Thúc',
    task: 'Nhiệm Vụ',
    taskName: 'Tên Nhiệm Vụ',
    taskPlaceholder: 'Vui lòng chọn nhiệm vụ',
    taskNamePlaceholder: 'Vui lòng chọn tên nhiệm vụ',
    taskType: 'Loại Nhiệm Vụ',
    taskTypePlaceholder: 'Vui lòng chọn loại nhiệm vụ',
    username: 'Tên Người Dùng',
    userName: 'Tên Người Dùng',
    user: 'Người Dùng',
    usernamePlaceholder: 'Vui lòng nhập tên người dùng',
    userNamePlaceholder: 'Vui lòng nhập tên người dùng',
    userPlaceholder: 'Vui lòng nhập tên người dùng',
    phone: 'Số Điện Thoại',
    phonePlaceholder: 'Vui lòng nhập số điện thoại',
    channel: 'Kênh',
    channelPlaceholder: 'Vui lòng chọn kênh',
    status: 'Trạng Thái',
    statusPlaceholder: 'Vui lòng chọn trạng thái',
    receipt: 'Mã Biên Lai',
    receiptPlaceholder: 'Vui lòng nhập mã biên lai',
    updateTime: 'Thời Gian Cập Nhật',
    updateTimePlaceholder: 'Vui lòng chọn thời gian cập nhật'
  },

  // Table related
  table: {
    time: 'Thời Gian',
    task: 'Nhiệm Vụ',
    user: 'Người Dùng',
    phone: 'Điện Thoại',
    channel: 'Kênh',
    status: 'Trạng Thái',
    receipt: 'Biên Lai'
  },

  // Status related
  status: {
    pending: 'Đang Chờ',
    success: 'Thành Công',
    failed: 'Thất Bại',
    unknown: 'Không Xác Định'
  },

  // Export related
  export: {
    button: 'Xuất',
    loading: 'Tác vụ xuất đã được tạo. Vui lòng kiểm tra tiến trình trong danh sách tải xuống.',
    statusNotFailed: 'Chỉ hỗ trợ xuất các bản ghi có trạng thái "Thất bại". Vui lòng đặt bộ lọc trạng thái thành "Thất bại" trước khi xuất.',
    noData: 'Không có dữ liệu để xuất',
    tooMany: 'Tối đa 100.000 bản ghi mỗi lần xuất. Vui lòng thu hẹp bộ lọc.'
  },

  // Message related
  message: {
    queryFailed: 'Truy vấn thất bại',
    exportSuccess: 'Xuất thành công',
    exportFailed: 'Xuất thất bại'
  },

  // Pagination related
  pagination: {
    total: 'Tổng cộng {{total}} bản ghi'
  }
};
